import Icon from '@/components/icon/Icon';
import type NavigationItem from '@/types/NavigationItem';
import Link from 'next/link';
import React from 'react';

export interface LinkNavigationItemProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  data?: NavigationItem;
  icon?: string;
}

const LinkNavigationItem = React.forwardRef<HTMLAnchorElement, LinkNavigationItemProps>(
  ({data, ...props}, ref) => {
    if (!data) return null;

    const commonProps = {ref, ...props};

    switch (data.linkType) {
      case 'external':
        return (
          <Link
            href={data.url ?? ''}
            target={(data.url ?? '').includes('http') ? '_blank' : undefined}
            {...commonProps}
          >
            {data.icon && <Icon name={data.icon} size={16} className="mr-1" />}
            {data.label}
          </Link>
        );
      case 'page':
        return (
          <Link href={`/${data.pageSlug}${data.anchor ? `#${data.anchor}` : ''}`} {...commonProps}>
            {data.icon && <Icon name={data.icon} size={16} className="mr-1" />}
            {data.label}
          </Link>
        );
      default:
        return null;
    }
  }
);

LinkNavigationItem.displayName = 'LinkNavigationItem';

export default LinkNavigationItem;
